/**
 * InviteHeading
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';
import Icon from 'components/media/Icon/index.js';

const BigIcon = styled(Icon)`
  color: ${(p) => p.theme.brandPrimary};
  font-size: 48px;
  margin-top: 20px;
`;

function InviteHeading(props) {
  const { icon, title } = props;
  return (
    <Card.Header className="d-flex flex-column align-items-center border-0">
      <BigIcon className={icon} />
      <h3 className="mt-3"><FormattedMessage {...title} /></h3>
    </Card.Header>
  );
}

InviteHeading.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
};

export default InviteHeading;
